import { Icon, IconButton, IconButtonProps, Tooltip } from '@chakra-ui/react'
import { ArrowUpDown } from 'lucide-react'

interface Props extends Omit<IconButtonProps, 'aria-label'> {}

const Component = ({ isLoading, onClick, ...props }: Props) => {
  return (
    <Tooltip label="Nova transação">
      <IconButton
        colorScheme="primary"
        aria-label="Transação"
        isLoading={isLoading}
        onClick={onClick}
        icon={<Icon as={ArrowUpDown} />}
        {...props}
      />
    </Tooltip>
  )
}

export default Component
